import { isNonNullObject } from '../type-guards/type-guards.utils';

const DEFAULT_REVISION = 1;

/**
 * Calculates the latest revision number from an object's revisionObjects array.
 *
 * @param object - Any value that may contain a revisionObjects array with revisionNr properties.
 * @returns The maximum revisionNr found, or 1 if no valid revisions exist.
 */
export function getLatestRevision(object: unknown): number {
  if (!isNonNullObject(object) || !('revisionObjects' in object)) {
    return DEFAULT_REVISION;
  }

  const revisions = object.revisionObjects;
  if (!Array.isArray(revisions) || revisions.length === 0) {
    return DEFAULT_REVISION;
  }

  const validRevisionNumbers = revisions
    .map(revision => revision?.revisionNr ?? 0)
    .filter((nr): nr is number => nr > 0);

  return validRevisionNumbers.length > 0 ? Math.max(...validRevisionNumbers) : DEFAULT_REVISION;
}
